require('./mortgagePropertyValueDefined.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { TAS_DICT, TAS_FACT, TAS_CERT } = require('constants/mortgageRequestDocumentsTypes');
const { formatCurrency, formatAmount, formatNumber } = require('utilities/currencyHelper');

// @ actions
const mortgageRequestPropertyValueDefined = require('actions/mortgageRequest/mortgageRequestPropertyValueDefined');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

// @ constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

class MortgagePropertyValueDefined extends React.Component {
    constructor(props) {
        super(props);

        this.buildPDFLinks = this.buildPDFLinks.bind(this);
    }

    componentWillMount() {
        this.props.requestSummaryDocumentation();
    }

    componentWillUnmount() {
        this.props.resetPropertyValueState();
    }

    buildLink(docType, fileName, linkText, emptyText) {
        if (this.checkFile(docType)) {
            return (
                <a
                    onClick={evt => this.handleDocumentDownload(evt, docType)}
                    className="mortgage-property-value-defined__download-link"
                >
                    <i className="ok-link__icon icon-documento mortgage-property-value-defined__download-icon" />
                    {linkText}
                </a>
            );
        }

        return emptyText;
    }

    buildPDFLinks() {
        const { summaryDocsState } = this.props;

        let linkTasDict = <LoadingSection />;
        let linkTasFact = <LoadingSection />;
        let linkTasCert = <LoadingSection />;

        if (!summaryDocsState.get('isFetching')) {
            linkTasDict = this.buildLink(
                TAS_DICT,
                formatText('mortgagePropertyValueDefined-appraisalDocumentName'),
                formatText('mortgagePropertyValueDefined-labelResumeLink'),
                formatText('mortgagePropertyValueDefined-emptyAppraisalReport')
            );

            linkTasCert = this.buildLink(
                TAS_CERT,
                formatText('mortgagePropertyValueDefined-appraisalCertificateName'),
                formatText('mortgagePropertyValueDefined-labelCertificateLink'),
                formatText('mortgagePropertyValueDefined-emptyAppraisalCertificate')
            );

            linkTasFact = this.buildLink(
                TAS_FACT,
                formatText('mortgagePropertyValueDefined-appraisalBillName'),
                formatText('mortgagePropertyValueDefined-labelBillLink'),
                formatText('mortgagePropertyValueDefined-emptyAppraisalBill')
            );
        }

        return (
            <div>
                <div className="mortgage-property-value-defined__download-resume col-xs-4">
                    {linkTasDict}
                </div>
                <div className="mortgage-property-value-defined__download-certificate col-xs-4">
                    {linkTasCert}
                </div>
                <div className="mortgage-property-value-defined__download-bill col-xs-4">
                    {linkTasFact}
                </div>
            </div>
        );
    }

    checkFile(docType) {
        const { summaryDocsState } = this.props;
        const fileIdx = summaryDocsState.get('data').findIndex(item =>
            item.get('tipoDocumentoId') === docType &&
            item.get('estado') !== DOCUMENTS_STATUS.NONE &&
            item.get('estado') !== DOCUMENTS_STATUS.PEND_APORTAR &&
            item.get('estado') !== DOCUMENTS_STATUS.EXENTO
        );

        return fileIdx !== -1;
    }

    handleDocumentDownload(evt, documentType) {
        evt.preventDefault();

        this.props.requestDocument({
            documentType
        });
    }

    render() {
        const { mortgagePropertyValueDefined } = this.props;
        const currencyFormatted = formatCurrency('EUR');

        return (
            <div className="mortgage-property-value-defined">
                <ContentBox>
                    <div className="mortgage-property-value-defined__header-box row">
                        <div className="mortgage-property-value-defined__header-info col-xs-9">
                            <h4 className="mortgage-property-value-defined__header-title">
                                {formatText('mortgagePropertyValueDefined-labelPropertyValue')}
                            </h4>
                            <p>
                                {formatText('mortgagePropertyValueDefined-labelPropertyValueDescription')}
                            </p>
                        </div>
                        <div className="mortgage-property-value-defined__header-amount col-xs-3">
                            <h4 className="mortgage-property-value-defined__amount">
                                {formatAmount(
                                    mortgagePropertyValueDefined.get('importeTasado')
                                )}
                                {currencyFormatted}
                            </h4>
                            <p>
                                {formatText('mortgagePropertyValueDefined-labelPropertyIvaIncluded')}
                            </p>
                        </div>
                    </div>
                    <div className="mortgage-property-value-defined__content">
                        <div>
                            <OKBoxTitle
                                value={formatText('mortgagePropertyValue-title')}
                                size="medium"
                            />
                        </div>
                        <div className="mortgage-property-value-defined__content-info row">
                            <div className="col-xs-6">
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelId"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {mortgagePropertyValueDefined.get('identificadorCatastral')}
                                    </span>
                                </div>
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelSurface"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {formatNumber(mortgagePropertyValueDefined.get('superficieParcela'))} &nbsp; m<sup>2</sup>
                                    </span>
                                </div>
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelSurfaceComp"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {formatNumber(mortgagePropertyValueDefined.get('superficieTotalComputable'))} &nbsp; m<sup>2</sup>
                                    </span>
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelMaintenance"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {mortgagePropertyValueDefined.get('conservacionInmueble')}
                                    </span>
                                </div>
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelOccupant"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {mortgagePropertyValueDefined.get('ocupanteActual')}
                                    </span>
                                </div>
                                <div className="mortgage-property-value-defined__content-line row">
                                    <FormattedText
                                        className="mortgage-property-value-defined__label col-xs-6"
                                        value="mortgagePropertyValueDefined-labelAntiquity"
                                    />
                                    <span className="mortgage-property-value-defined__info col-xs-6">
                                        {formatText('mortgagePropertyValueDefined-labelYearsAntiquity', [mortgagePropertyValueDefined.get('antiguedadVivienda')])}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="mortgage-property-value-defined__links row">
                            {this.buildPDFLinks()}
                        </div>
                    </div>
                    <hr />
                    <div className="clearfix">
                        <OKLink modifier="emphasize" to="/myprofile/mortgage/panel">
                            {formatText('mortgageRequestCommons-returnText')}
                        </OKLink>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

MortgagePropertyValueDefined.propTypes = {
    mortgagePropertyValueDefined: PropTypes.object,
    summaryDocsState: PropTypes.object,
    resetPropertyValueState: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func
};

module.exports.constructor = MortgagePropertyValueDefined;

module.exports.MortgagePropertyValueDefined = connect(
    state => ({
        mortgagePropertyValueDefined: state.mortgageRequestPropertyValueDefined,
        summaryDocsState: state.mortgageRequestSummaryDocumentation
    }),
    {
        resetPropertyValueState: mortgageRequestPropertyValueDefined.resetPropertyValueState,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        requestDocument: documentActions.getDocument
    }
)(MortgagePropertyValueDefined);
